export const ASSIGNMENT_STATUS = ["รอดำเนินการ", "กำลังดำเนินการ", "เสร็จสิ้น", "ยกเลิก","พร้อม"];

